import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_projects/cwd-website/src/components/About/AboutPageContent.tsx");
